import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface OnboardingPageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
}

const OnboardingPageHeader = ({
  eyebrow,
  title,
  subtitle,
  actions,
  className,
}: OnboardingPageHeaderProps) => (
  <header
    className={cn(
      'mb-5 flex items-start justify-between gap-4 max-[960px]:flex-col max-[960px]:items-stretch',
      className,
    )}>
    <div className="max-w-[42rem]">
      {eyebrow ? (
        <div className="mb-3 inline-flex items-center gap-2.5 text-[0.6875rem] font-semibold uppercase tracking-[0.16em] text-[var(--inv-accent)]">
          <span
            className="h-[2px] w-5 rounded-full bg-[var(--inv-accent)]"
            aria-hidden="true"
          />
          {eyebrow}
        </div>
      ) : null}
      <h1 className="m-0 mb-2 font-serif text-[clamp(1.375rem,2.4vw,2rem)] font-medium leading-[1.12] tracking-[-0.015em] text-[var(--inv-text)]">
        {title}
      </h1>
      {subtitle ? (
        <p className="m-0 max-w-[42rem] text-[0.875rem] font-normal leading-[1.55] text-[var(--inv-text-secondary)]">
          {subtitle}
        </p>
      ) : null}
    </div>
    {actions ? <div className="shrink-0">{actions}</div> : null}
  </header>
);

export default OnboardingPageHeader;
